import useGraphQLRequest from './useGraphQLRequest';
import { GET_TAX_FORM_URL } from '@mp/graphql';

interface IUseTaxFormReturn {
  fetchTaxForms: (id: number) => void;
}

const useTaxFormUrl = (): IUseTaxFormReturn => {
  const { request } = useGraphQLRequest();

  const fetchTaxForms = async (id: number) => {
    const result = (await request(GET_TAX_FORM_URL, { id })) as { taxForm: unknown };

    return result.taxForm;
  };

  return { fetchTaxForms };
};

export default useTaxFormUrl;
